var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoins(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 21,
    viewBox: "0 0 29 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.667%",
    y1: "49.464%",
    x2: "55.667%",
    y2: "56.016%",
    id: "2e9ssccn5a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB44",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEF06",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.522%",
    y1: "49.272%",
    x2: "51.367%",
    y2: "50.453%",
    id: "2fmx6w4gxb"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB44",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEF06",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.667%",
    y1: "49.464%",
    x2: "55.722%",
    y2: "56.016%",
    id: "bt4nae458c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB44",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEF06",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.424%",
    y1: "49.275%",
    x2: "51.32%",
    y2: "50.452%",
    id: "jdoylhujxd"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB44",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEF06",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.611%",
    y1: "49.457%",
    x2: "55.667%",
    y2: "56.016%",
    id: "36pkmv6jne"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB44",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEF06",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.684%",
    y1: "49.269%",
    x2: "51.533%",
    y2: "50.455%",
    id: "kmwnqm5u8f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB44",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEF06",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.49.65a17.1 17.1 0 0 0-1.66.52 7.94 7.94 0 0 0-1.57.15 7.68 7.68 0 0 0-1.7.52 1.89 1.89 0 0 0-.21.09H7.14l-.2.11h-.11l-.1.06-.4.26-.19.14-.09.07-.1.08a6.18 6.18 0 0 0-1.27 1.58 1.37 1.37 0 0 0-.13.2l-.12.21v.1l-.05.11-.06.11v.11l-.19.25v.35l-.05.14v.1l-.25.28a.5.5 0 0 0 0 .13v.29a.43.43 0 0 0 0 .05 2 2 0 0 0 0 .23.49.49 0 0 0 0 .12V7.81a5.68 5.68 0 0 0 .38 1.71v.2c0 .06 0 .13.08.19.06.12.11.24.18.36v.09l.11.18.06.08.11.16c.291.388.627.74 1 1.05a5.87 5.87 0 0 0 1 .69l.12.06.11.06.21.11.19.08h.19l.16.06h.12l1-2.47 1.21 2.23 2.76 5.15-8 2.59 1.05-2.62h-.08l-.25-.13-.14-.08-.08-.05h-.07l-.29-.18-.16-.1-.03.09-.34-.24-.36-.27-.18-.16-.19-.16a11.06 11.06 0 0 1-1.51-1.59 10.59 10.59 0 0 1-1.3-2.15c0-.1-.09-.2-.13-.3l-.07-.16V12.14c0-.1-.07-.21-.11-.31v-.33c-.07-.21-.12-.43-.18-.65-.06-.22 0-.22-.07-.34v-.33a9.12 9.12 0 0 1 0-2.76l.06-.34c0-.12 0-.23.07-.34v-.5a.84.84 0 0 1 0-.17c0-.11.07-.22.1-.33.03-.11 0-.06 0-.08v-.08l.08-.16.07-.16.12-.18.15-.31v-.06l.07-.13v-.06l.1-.16.09-.15V4.06c.07-.09.13-.19.19-.28l.11-.13.29-.33.11-.13.11-.13c.07-.08.14-.17.22-.25l.23-.24a8.55 8.55 0 0 1 2.13-1.51l.14-.07.14-.07.28-.13c.2-.08.38-.17.58-.23h.28l.29-.09H6.63A1.28 1.28 0 0 1 6.91.4 10.13 10.13 0 0 1 8.39.19h.68c.611.011 1.22.075 1.82.19h.38l.35.09.32.1H12.23l.26.08z",
    fill: "#F4C338"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.167.63a17.1 17.1 0 0 0-1.66.52 7.94 7.94 0 0 0-1.57.15 7.68 7.68 0 0 0-1.7.52 1.89 1.89 0 0 0-.21.09H5.817l-.2.11h-.11l-.1.06-.4.26-.19.14-.09.07-.1.08a6.18 6.18 0 0 0-1.27 1.58 1.37 1.37 0 0 0-.13.2l-.12.21v.1l-.05.11-.06.11v.11l-.19.25v.35l-.05.14v.1l-.25.28a.5.5 0 0 0 0 .13v.29a.43.43 0 0 0 0 .05 2 2 0 0 0 0 .23.49.49 0 0 0 0 .12V7.79a5.68 5.68 0 0 0 .38 1.71v.2c0 .06 0 .13.08.19A6.63 6.63 0 0 1 7.067 0h.68c.61.011 1.22.075 1.82.19h.38l.35.09.32.1H10.907l.26.25z",
    fill: "#FFCC16",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.06 8.84v2c0 .64 4 1.16 9 1.16s9-.52 9-1.16v-2h-18z",
    fill: "#F4C338"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.01 8.84c0 .64-4 1.16-9 1.16s-9-.52-9-1.16c0-.64 4-1.17 9-1.17s9 .53 9 1.17z",
    fill: "url(#2e9ssccn5a)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.04 10.08c-4.39 0-9-.42-9-1.22 0 0 0-.13.06-.13s0 .06 0 .11c0 .51 3.65 1.08 8.9 1.08s8.93-.6 8.93-1.08v-.09.11c.08.8-4.51 1.22-8.89 1.22z",
    fill: "url(#2fmx6w4gxb)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m18.19 8.9.28-.18a2 2 0 0 1 .38-.16 3.61 3.61 0 0 1 .6-.11 5.49 5.49 0 0 1 .88-.05h1c.269.017.536.054.8.11.197.032.388.089.57.17.14.07.23.15.25.24h1.28v.09h-1.3a.62.62 0 0 1-.35.28 3 3 0 0 1-.71.22l-.47-.06H21.25l.11-.06.25-.07.27-.11a.35.35 0 0 0 .18-.15h-3.07l-.27.18a1.87 1.87 0 0 1-.39.15 3 3 0 0 1-.62.11 7.88 7.88 0 0 1-.93.05h-.82c-.26 0-.51-.06-.72-.1a2.75 2.75 0 0 1-.51-.17c-.13-.07-.21-.15-.22-.23h-1.12v-.09h1.14a.56.56 0 0 1 .31-.23 3.08 3.08 0 0 1 .58-.18l.38.06c.11 0 .17 0 .17.05s0 0-.07.05l-.17.06-.19.08a.42.42 0 0 0-.14.12l2.79-.07zm-2.81.12a.29.29 0 0 0 .15.14c.093.042.19.076.29.1l.39.05h.45c.163.012.327.012.49 0a1.93 1.93 0 0 0 .36-.06 1.07 1.07 0 0 0 .27-.09 1.39 1.39 0 0 0 .21-.11l-2.61-.03zm6.68-.08a.35.35 0 0 0-.17-.14 1.82 1.82 0 0 0-.33-.11 3 3 0 0 0-.47-.06c-.2-.01-.4-.01-.6 0a3.48 3.48 0 0 0-.49 0 1.68 1.68 0 0 0-.36.06 1.28 1.28 0 0 0-.26.1l-.2.11 2.88.04z",
    fill: "#FCB048"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.04 7.8c-4 0-8.17.35-8.84 1l.08.08c.56-.47 4-.95 8.76-.95s8.37.5 8.8 1l.06-.08c-.55-.69-4.79-1.05-8.86-1.05z",
    fill: "#F4C338"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57 6.75v2c0 .64 4 1.16 9 1.16s9-.52 9-1.16v-2h-18z",
    fill: "#F4C338"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.51 6.75c0 .64-4 1.16-9 1.16s-9-.52-9-1.16c0-.64 4-1.17 9-1.17s9 .52 9 1.17z",
    fill: "url(#bt4nae458c)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.54 7.99c-4.39 0-9-.42-9-1.23 0 0 0-.12.06-.12s0 .06 0 .11c0 .51 3.65 1.08 8.89 1.08s8.89-.57 8.89-1.08c0 0 0-.09.06-.09s0 .06 0 .11c.08.8-4.51 1.22-8.9 1.22z",
    fill: "url(#jdoylhujxd)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m15.69 6.81.28-.18a1.84 1.84 0 0 1 .39-.16 3.38 3.38 0 0 1 .59-.12 7.41 7.41 0 0 1 .88-.03h1c.272.016.543.053.81.11.194.03.382.087.56.17a.44.44 0 0 1 .26.24h1.28v.08h-1.31a.65.65 0 0 1-.35.28 3.15 3.15 0 0 1-.71.22l-.48-.06h-.1l.04-.04.25-.07.27-.11a.35.35 0 0 0 .18-.15h-3.07l-.27.18a1.78 1.78 0 0 1-.36.15 3.7 3.7 0 0 1-.62.11 7.63 7.63 0 0 1-.93.05h-.82a5.93 5.93 0 0 1-.71-.11 2.2 2.2 0 0 1-.51-.16.39.39 0 0 1-.23-.23H10.9v-.09h1.13a.63.63 0 0 1 .32-.23 3 3 0 0 1 .57-.18h.38c.12 0 .18.02.18.06l-.07.05-.17.06-.19.08a.42.42 0 0 0-.14.11l2.78-.03zm-2.8.12a.29.29 0 0 0 .15.14.9.9 0 0 0 .29.09 2 2 0 0 0 .39.06h.45c.16.011.32.011.48 0a1.68 1.68 0 0 0 .36-.06.85.85 0 0 0 .27-.09 1 1 0 0 0 .21-.11l-2.6-.03zm6.67-.08a.32.32 0 0 0-.16-.14 1.23 1.23 0 0 0-.34-.11 2.85 2.85 0 0 0-.47-.06 5.43 5.43 0 0 0-.59 0h-.5l-.36.07a1.28 1.28 0 0 0-.26.1 1.18 1.18 0 0 0-.19.11l2.87.03z",
    fill: "#FCB048"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M16.54 5.71c-4 0-8.17.35-8.83 1l.07.08c.56-.47 4-.95 8.76-.95s8.38.5 8.8 1a.27.27 0 0 1 .07-.08c-.58-.69-4.8-1.05-8.87-1.05z",
    fill: "#F4C338"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72 4.66v2c0 .65 4 1.17 9 1.17s9-.52 9-1.17v-2h-18z",
    fill: "#F4C338"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.67 4.66c0 .65-4 1.17-9 1.17s-9-.52-9-1.17c0-.65 4-1.16 9-1.16s9 .52 9 1.16z",
    fill: "url(#36pkmv6jne)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.69 5.91c-4.39 0-9-.42-9-1.23 0 0 0-.12.06-.12s0 .06 0 .1c0 .52 3.65 1.09 8.89 1.09s8.9-.57 8.9-1.09v-.08.1c.13.81-4.46 1.23-8.85 1.23z",
    fill: "url(#kmwnqm5u8f)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.69 3.62c-4 0-8.16.36-8.83 1a.46.46 0 0 1 .07.07c.56-.47 4-.94 8.76-.94s8.38.5 8.8 1l.07-.07c-.55-.69-4.79-1.06-8.87-1.06z",
    fill: "#F4C338"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.4169844044cfbca052c2d4b5d1606ebe.svg";
export { ForwardRef as ReactComponent };